import { render, staticRenderFns } from "./PermissionOfficeStaffExporter.vue?vue&type=template&id=0778dc5e&scoped=true"
import script from "./PermissionOfficeStaffExporter.vue?vue&type=script&lang=js"
export * from "./PermissionOfficeStaffExporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778dc5e",
  null
  
)

export default component.exports